import { useState, useEffect } from 'react';
import { getModelAssetsAvailable } from 'services/analytics';
import { useDispatch } from 'react-redux';
import { showError } from '../../../../../redux/common/actions';
import { SHOW_ALL_OPTION } from '../../constants';

export const useAssets = (modelId, showAll = true) => {
  const dispatch = useDispatch();
  const [assets, setAssets] = useState([]);

  useEffect(() => {
    const loadAssets = async () => {
      if (!modelId) {
        setAssets([]);
        return;
      }
      
      try {
        const response = await getModelAssetsAvailable({ modelId });
        if (response?.status) {
          const fetchedAssets = response.data || [];
          const formattedAssets = fetchedAssets.map(a => ({
            id: a.siteAssetRegisterID || a.id,
            name: a.assetNumber || a.name
          }));

          // Conditionally add 'Show All' if assets exist and showAll is true
          const updatedAssets = (showAll && formattedAssets.length > 0)
            ? [SHOW_ALL_OPTION, ...formattedAssets]
            : formattedAssets;
          setAssets(updatedAssets);
        }
      } catch (error) {
        dispatch(showError('Failed to load assets'));
        setAssets([]); // Reset on error
      }
    };
    loadAssets();
  }, [modelId, showAll]);

  return assets;
}; 
